"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _constants = require("./constants");

var _Dropdown = _interopRequireDefault(require("./Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Dropdown["default"]); // eslint-disable-line


var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var domNode = _reactDom["default"].findDOMNode(_assertThisInitialized(_this)); // eslint-disable-line react/no-find-dom-node


      var open = _this.state.open;

      if (!domNode || !domNode.contains(event.target)) {
        if (open) {
          _this.toggleMenu();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (e) {
      var filter = _this.props.filter;
      var value = e.target.value;

      _this.setState({
        filterString: value
      });

      filter.onFilterChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function (e) {
      var toggleListener = _this.props.toggleListener;
      var open = _this.state.open;

      if (e !== undefined) {
        _this.setState({
          open: !open
        }, function () {
          var changedOpen = _this.state.open;

          if (toggleListener) {
            toggleListener(changedOpen);
          }
        });
      }
    });

    var _this$props = _this.props,
        isOpen = _this$props.isOpen,
        _filter = _this$props.filter;
    _this.state = {
      open: isOpen,
      filterString: _filter.filterString
    };
    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.isOpen
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          dimensions = _this$props2.dimensions,
          filter = _this$props2.filter,
          headerContent = _this$props2.headerContent,
          minWidth = _this$props2.minWidth;
      var _this$state = this.state,
          filterString = _this$state.filterString,
          open = _this$state.open;
      return _react["default"].Children.map(children, function (child) {
        // Those have different props so it should be treated properly
        // otherwise you will get: https://reactjs.org/warnings/unknown-prop.html
        if (child.type.displayName === 'DropdownToggle') {
          return _react["default"].cloneElement(child, {
            dimensions: dimensions,
            open: open,
            toggleMenu: _this2.toggleMenu,
            filter: {
              filterString: filterString,
              isVisible: filter.isVisible,
              onFilterChange: _this2.handleFilterChange,
              placeholder: filter.placeholder
            }
          });
        }

        if (child.type.displayName === 'Menu') {
          return _react["default"].cloneElement(child, {
            dimensions: dimensions,
            headerContent: headerContent,
            minWidth: minWidth,
            open: open,
            toggleMenu: _this2.toggleMenu,
            filter: {
              filterString: filterString,
              isVisible: filter.isVisible,
              onFilterChange: _this2.handleFilterChange,
              placeholder: filter.placeholder
            }
          });
        }

        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      /* eslint-disable jsx-a11y/no-static-element-interactions,
        jsx-a11y/click-events-have-key-events
      */

      return /*#__PURE__*/_react["default"].createElement("div", {
        "aria-pressed": "false",
        className: cx('dropdown', className),
        role: "button",
        tabIndex: -1
      }, this.renderChildren());
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  dimensions: _constants.DROPDOWN_DIMENSIONS_PROP_TYPE,
  filter: _constants.DROPDOWN_FILTER_PROP_TYPE,
  headerContent: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  minWidth: _propTypes["default"].number,
  toggleListener: _propTypes["default"].func
};
Dropdown.defaultProps = {
  children: null,
  dimensions: _constants.DROPDOWN_DIMENSIONS_DEFAULT_PROP,
  minWidth: null,
  toggleListener: null,
  headerContent: '',
  isOpen: false,
  filter: _constants.DROPDOWN_FILTER_DEFAULT_PROP,
  className: null
};
var _default = Dropdown;
exports["default"] = _default;